import { connect } from "react-redux";
import useQueryParams from "../../customHooks/useQueryParams";
import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, FormGroup, Label, Row, Spinner } from "reactstrap";

import ButtonCustom from "../../components/Buttons/ButtomCustom";
import { useForm } from "react-hook-form";
import { cleanMessageRegion, getRegion, loadEmptyRegion, saveRegion, } from "../../store/actions";
import { useEffect } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import { useNavigate } from "react-router-dom";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";

const RegionDetail = ({
	loadEmptyRegion,
	saveRegionRequest,
	getRegionRequest,
	cleanMessageRegion,
	isRegionSave,
	messageRegion,
	region, 
	loadingRegion,
	errorLoadingRegion,
}) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
	} = useForm({
    defaultValues: {
      active: true,
    }
  });

	const alertModal = withReactContent(Swal);
	const navigate = useNavigate();
	
	const params = useQueryParams();
	const id = params.get("id");

	function handleBack() {
		loadEmptyRegion();
		navigate("/regions");
	}
	function handleSave(values) {
		const method = id === null ? "POST" : "PUT";
		if (id === null) {
			saveRegionRequest({
				body: {
					name: values.name, 
					active: values.active,
				}, 
				method: method
			})
		} else {
			saveRegionRequest({
				body: {
					id: id,
					name: values.name, 
					active: values.active,
				},
				method: method
			})
		}
	}
	
	const actions = useContextActions({
		context: "region",
		screen: "detail",
	});
	const editableWithSave = actions.some(e => e === "save");

	useEffect(() => {
		
		if (id !== null) {
			getRegionRequest({ regionId: id });
		}

		return () => {
			loadEmptyRegion();
			cleanMessageRegion();
		}
		// eslint-disable-next-line
	},[]);
	useEffect(() => {
		if (isRegionSave !== null) {
			alertModal
				.fire({
				title: isRegionSave === true ? `Region ${id === null ? "created" : "updated"} successfully!` : `${messageRegion !== null ? messageRegion : "Something wrong, try again later."}`,
				icon: isRegionSave === true ? "success" : "error",
				showConfirmButton: false,
				showCloseButton: true,
				timer: isRegionSave === true ? 2000 : undefined,
				timerProgressBar: isRegionSave === true ? true : false,
			}).then((result) => {
				if(isRegionSave) {
					if (result.dismiss) {
						cleanMessageRegion();
						navigate("/regions");
					}
				}
			
				if(result.dismiss) {
					cleanMessageRegion();
					loadEmptyRegion();
				}
			});
		}

		// eslint-disable-next-line
	},[isRegionSave]);
	useEffect(() => {
		if (errorLoadingRegion !== null) {
			alertModal
				.fire({
					title: "Something wrong, try again later.",
					icon: "error",
					showConfirmButton: false,
					showCloseButton: true,
					allowOutsideClick: false,
					//timer: 2000,
					//timerProgressBar: true,
				}).then((result) => {
					if (errorLoadingRegion) {
						if (result.dismiss) {
							cleanMessageRegion();
							loadEmptyRegion();
							navigate("/regions");
						}
					}
					if (result.dismiss) {
						cleanMessageRegion();
						loadEmptyRegion();
					}
				})
		}

		// eslint-disable-next-line
	}, [errorLoadingRegion]);
	useEffect(() => {
		if (!region) return
			setValuesHookForm(region, setValue);
			setValue("active", region.active ?? true);
		// eslint-disable-next-line
	}, [region]);

	return (
		<div className="page-content">
			<Helmet>
				<title>Region</title>
			</Helmet>
			<Container fluid>
				<Row>
					<Col xs={12}>
						<Card>
							<CardBody>
								<div>
									<Row className="my-2">
										{loadingRegion ? (
											<div
												className="d-flex align-items-center justify-content-center"
												style={{ height: "400px", width: "100%" }}
											>
												<Spinner
													color="primary"
													style={{ height: "5rem", width: "5rem" }}
												/>
											</div>
										) : (
											<>
											<form onSubmit={handleSubmit(handleSave)}>
												<div className="d-flex justify-content-between my-2">
													<h2>{id === null ? "CREATE" : "EDIT"} REGION</h2>
													<div className="d-flex gap-2 mb-4">
														<ButtonCustom
															type="cancel"
															onClick={() => handleBack()}
														/>
														<ActionButtons 
															actions={actions}
															handlers={{
																save: handleSubmit(handleSave),
															}}
														/>
													</div>
												</div>
												<Row>
													<Col md="4">
														<FormGroup className="mb-3">
															<Label
																htmlFor="name"
																className="label-detail-form"
															>
																Name
															</Label>
															<input
																className="form-control"
																id="name"
																type="text"
																disabled={!editableWithSave}
																style={!editableWithSave ? {color: "#00000060"} : {}}
																{...register("name", {
																	required: fieldsMessage.required("Region name"),
																	validate: (value) => value.trim() !== "" || fieldsMessage.required("Region name"),
																	maxLength: {
																		value: 100,
																		message: fieldsMessage.maxLength("Region name", 100),
																	}
																})}
															/>
															<p className="error-form">
																{errors.name?.message}
															</p>
														</FormGroup>
													</Col>
													<Col md="2">
														<FormGroup className="mb-3">
															<Label
																htmlFor="createUser"
																className="label-detail-form"
															>
																Created By
															</Label>
															<input
																className="form-control"
																id="createUser"
																{...register("createUser")}
																disabled
																style={{ color: '#00000060'}}
															/>
														</FormGroup>
													</Col>
													<Col md="2">
														<FormGroup className="mb-3">
															<Label
																id="createDate"
																className="label-detail-form"
															>
																Creation Date
															</Label>
															<input
																className="form-control"
																name="createDate"
																{...register("createDate")}
																disabled
																style={{ color: '#00000060'}}
															/>
														</FormGroup>
													</Col>
													<Col md="2">
														<FormGroup className="mb-3">
															<Label
																id="updateUser"
																className="label-detail-form"
															>
																Updated By
															</Label>
															<input
																className="form-control"
																name="updateUser"
																{...register("updateUser")}
																disabled
																style={{ color: '#00000060'}}
															/>
														</FormGroup>
													</Col>
													<Col md="2">
														<FormGroup className="mb-3">
															<Label
																id="updateDate"
																className="label-detail-form"
															>
																Update Date
															</Label>
															<input
																className="form-control"
																name="updateDate"
																{...register("updateDate")}
																disabled
																style={{ color: '#00000060'}}
															/>
														</FormGroup>
													</Col>
												</Row>
												<Row className="my-2 mb-4">
													<Col className="d-flex align-items-center">
														<FormGroup>
															<label htmlFor="active" className="label-check">
																<input
																	id="active"
																	type="checkbox"
																	className="form-check-input"
																	{...register("active")}
																	disabled={!editableWithSave}
																/>
																Active Status
															</label>
														</FormGroup>
													</Col>
												</Row>
											</form>
										</>
										)
										}
									</Row>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</div>
	)
};

const mapStateToProps = ({
	RegionReducer: {
	loadingRegion,
    filterRegion,
    dropdownRegion,
    region,
    messageRegion,
    isRegionSave,
		errorLoadingRegion,
	},
}) => ({
	loadingRegion,
	filterRegion,
	dropdownRegion,
	region,
	messageRegion,
	isRegionSave,
	errorLoadingRegion,
});

const mapDispatchToProps = {
	saveRegionRequest: saveRegion.request,
	getRegionRequest: getRegion.request,
	loadEmptyRegion,
	cleanMessageRegion,
}
	
export default connect(mapStateToProps, mapDispatchToProps)(RegionDetail);